import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import pick from "lodash/pick";
import Panel from "common/components/Panel";
import actions from "../actions";
import BuildingForm from "../Form";
import { transformApiError } from "common/api/errors";
import fields from "../fields";

const handleSubmit = async (values, form) => {
  const { setSubmitting, setErrors, setStatus, resetForm } = form;
  const body = {
    ...pick(values, fields),
    hours: JSON.stringify(values.hours),
  };

  try {
    const heroUrls = await actions.getURLForFiles(values.heroFile);
    body.hero_url = heroUrls.toString();
    const building = await actions.create(body);
    await actions.attachFiles(building.id, [
      {
        prop: "logo_url",
        name: "logo",
        file: values.logoFile,
      },
    ]);

    resetForm();
    setStatus({ success: true });
  } catch (error) {
    const apiError = transformApiError(error);

    if (apiError.empty()) {
      setErrors({ http: error.message });
    } else {
      setErrors(apiError.object());
    }
  }
  setSubmitting(false);
};

const CreateBuilding = ({ classes }) => (
  <Panel title="Create Building">
    <BuildingForm
      handleSubmit={handleSubmit}
      initialValues={{
        name: "",
        street_address: "",
        city: "",
        region: "",
        country: "",
        postal_code: "",
        primary_phone_number: "",
        website_url: "",
        description: "",
        community_id: 0,
        complex_name: "",
        floors: 1,
        is_hilo: undefined,
        tenant_id: 0,
        active: false,
        sign_up_inactive: false,
      }}
    />
  </Panel>
);

const styles = (theme) => ({
  button: {
    marginTop: theme.spacing(2),
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 180,
  },
});

CreateBuilding.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CreateBuilding);
